import { LoadingButton } from "@mui/lab";
import { Grid, Box, Link, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import Title from "../../app/components/Title";
import TitleSecondary from "../../app/components/TitleSecondary";
import { useAppDispatch, useAppSelector } from "../../app/store/configureStore";
import {
  entrezDbSelectors,
  setDbParams,
  updateSelectedDBState,
} from "../../app/store/entrezDbSlice";
//import FullScreenTableView from "./FullScreenTableView";

// interface Props {
//   // formattedQuery: string;
//   //onSearch: () => void;
// }
// props: Props
export default function FinalSearchOperationView() {
  console.log("Inside finalquery component");
  const { dbParams, status } = useAppSelector((state) => state.entrezDb);
  const dispatch = useAppDispatch();

  const selectedDbWithItsState = useAppSelector((state) =>
    entrezDbSelectors.selectById(state, dbParams.db)
  );

  var finalFormattedSearchTerm =
    selectedDbWithItsState?.finalFormattedSearchTerm;

  const [finalSearchTerm, setFinalSearchTerm] = useState("");

  useEffect(() => {
    console.log("useEffect - Final query changed: " + finalFormattedSearchTerm);

    setFinalSearchTerm(
      finalFormattedSearchTerm ? finalFormattedSearchTerm : ""
    );
  }, [finalFormattedSearchTerm]);

  // const finalQueryRef = useRef<any>();

  // debounce - to wait for a second before updating the REDUX state.
  // const debouncedUpdate = debounce((value: string) => {}, 100);

  const handleOnSearch = () => {
    console.log("On search clicked, finalSearchTerm is:" + finalSearchTerm);

    dispatch(setDbParams({ term: finalSearchTerm }));

    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          finalFormattedSearchTerm: finalSearchTerm,
          isReadyForSearch: true,
        },
      })
    );

    
  };

  const handleBlur = (value: string) => {
    console.log(
      "you moved away from final query text. Current value is: " + value
    );
    dispatch(
      updateSelectedDBState({
        id: dbParams.db,
        changes: {
          finalFormattedSearchTerm: value,
        },
      })
    );
  };

  const onFinalQueryChange = (value: string) => {
    console.log("Final query changed:" + value);
    setFinalSearchTerm(value);
    // debouncedUpdate(value);
    // }
  };

  return (
    <>
      <Box display="flex" flexDirection="row" justifyContent="space-between">
        {/* {selectedDbWithItsState?.eSearchResult && ( */}
        <>
          <Box display="flex" flexDirection="row" alignItems="left">
            {/* <Title sx={{mt:1}}></Title> */}
            <Typography
              sx={{ mt: 0 }}
              component="h2"
              variant="h6"
              color="primary"
              gutterBottom
            >
              Search Count:
            </Typography>
            <Typography
              sx={{ mt: 0 }}
              component="h2"
              variant="h6"
              color="secondary"
              gutterBottom
            >
              {selectedDbWithItsState?.eSearchResult ? (
                <Link
                  sx={{ ml: 1 }}
                  href={
                    "https://www.ncbi.nlm.nih.gov/" +
                    dbParams.db +
                    "/?term=" +
                    dbParams.term
                  }
                  target="_blank"
                  rel="noreferrer"
                  color="inherit"
                >
                  {selectedDbWithItsState.eSearchResult.count}
                </Link>
              ) : (
                ""
              )}
            </Typography>
          </Box>
        </>
        {/* )} */}

        {/*<FullScreenTableView></FullScreenTableView>*/}

        <LoadingButton
          disabled={
            finalFormattedSearchTerm === "" ||
            !selectedDbWithItsState?.fieldlist
          }
          onClick={handleOnSearch}
          loading={status.includes("pendingEFetchSearchResults")}
          sx={{
            textAlign: "center",
            backgroundColor: "secondary.main",
            height: "34px",
            mr: 3,
          }}
          variant="contained"
        >
          Search
        </LoadingButton>
      </Box>
    </>
  );
}

// <Grid item lg={12} md={12} sm={12} xs={12}>
// {/* <TextField
//   disabled
//   variant="outlined"
//   fullWidth
//   multiline
//   rows={4}
//   value={finalSearchTerm}
//   onBlur={(event: any) => {
//     handleBlur(event.target.value);
//   }}
//   onChange={(event: any) => {
//     onFinalQueryChange(event.target.value);
//   }}
//   // inputRef={finalQueryRef}
// ></TextField> */}

// <Paper
//   sx={{
//     minHeight: 120,
//     p: 1,
//     display: "flex",
//   }}
// >
//   <Box display="flex" flexDirection="column">
//     <Title>Final Query</Title>
//     <Typography variant="body2">{finalSearchTerm}</Typography>
//   </Box>
// </Paper>
// {/* <Typography >{props.formattedQuery}</Typography> */}
// </Grid>
